import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class StoneShields extends Component {
  render() {
    return (
      <EntityList apiRoute='api/stoneshields' title='Remorque - Pare-pierres' editTitle='Pare-pierres' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default StoneShields;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/stoneShields.js
 **/